<div class="expansions-wrap w-100">
    <div class="desc" i18n>Search and select the participants</div>
    <div class="users-wrap" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px">
        <div fxLayout="row" fxLayoutGap="20px" class="w-100" fxLayoutGap.lt-md="10px">
            <mat-form-field class="small-field users-rec-input default-select-user w-100" appearance="fill">
                <input
                    type="text"
                    matInput
                    #userRecieverInput
                    i18n-placeholder
                    placeholder="Search"
                    [formControl]="userCtrl"
                    [matAutocomplete]="autoUser"
                />
                <mat-autocomplete #autoUser="matAutocomplete" (optionSelected)="selected(autoUser, $event)">
                    <mat-option *ngFor="let user of userSearch$ | async" [value]="user">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-icon> {{ user.role_value | userRoleIcon }}</mat-icon>
                            <span>{{ user.name }}</span>
                        </div>
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAl>
            <mat-chip-list
                *ngIf="participantUsers.length"
                class="reci-chips mb-1"
                #chipList
                aria-label="Recievers selection"
            >
                <mat-chip
                    *ngFor="let recipient of participantUsers"
                    (removed)="removeUser(recipient)"
                    [selectable]="false"
                    class="users-wrap"
                    [ngClass]="{
                        'dark-blue-bg': recipient.role_value === 'user',
                        'green-bg': recipient.role_value !== 'user'
                    }"
                >
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                        <mat-icon>{{ recipient.role_value | userRoleIcon }}</mat-icon>
                        <span>{{ recipient.fname }}</span>
                        <span> {{ recipient.lname }}</span>
                    </div>
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip></mat-chip-list
            >
        </div>
    </div>
</div>
